import { applianceConstants } from "../_constants";
import { applianceService } from "../_services";
import { alertActions } from "./";
//import { history } from '../_helpers';

export const applianceActions = {
  getDetail
};

function getDetail(user, id) {
  return dispatch => {
    dispatch(request());

    applianceService.getDetail(user, id).then(
      detail => {
        dispatch(success(detail));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: applianceConstants.DETAIL_REQUEST };
  }
  function success(detail) {
    return { type: applianceConstants.DETAIL_SUCCESS, detail };
  }
  function failure(error) {
    return { type: applianceConstants.DETAIL_FAILURE, error };
  }
}
